import {EventModelState, updateEventSolutionDetailsObject} from "src/state/slice/EventModelSlice";
import {Checkbox, InputWrapper} from "@amzn/stencil-react-components/form";
import React from "react";
import {useAppDispatch, useAppSelector} from "src/state/hooks";
import {SolutionDetailAttribute} from "src/entity/entities";
import * as solutionConfig from "src/config/solutionConfigs.json";
import {Col} from "@amzn/stencil-react-components/layout";

interface ICheckboxInput {
    attributeName: string;
    attributeValue: string;
}

export const CheckboxInput = ({attributeName, attributeValue}: ICheckboxInput) => {

    const dispatch = useAppDispatch();
    return <Checkbox name="checkbox"
                     id="box1"
                     defaultChecked={Boolean(attributeValue)}
                     onChange={e => {
                         dispatch(updateEventSolutionDetailsObject({
                             [attributeName]: e.target.checked,
                         }));
                     }}
    />
}
